var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLightIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.01 4.82799L10.0828 14.7867C7.71909 15.9686 7.20565 19.1267 9.07534 20.9964L19.0438 30.9552C20.9135 32.8249 24.0716 32.3114 25.2535 29.9477L35.2122 10.0205C36.8785 6.68799 33.3425 3.16174 30.01 4.82799Z",
    fill: "#2953FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9901 43.1715L36.9173 33.2127C39.281 32.0309 39.7944 28.8727 37.9248 27.0031L27.9563 17.0443C26.0866 15.1746 22.9285 15.6881 21.7466 18.0518L11.7879 37.979C10.1216 41.3115 13.6576 44.8377 16.9901 43.1715Z",
    fill: "#FCCA1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightIcon);
export default __webpack_public_path__ + "static/media/light-icon.8fe5a4b332be5afe5f9759f7b6fa1cfd.svg";
export { ForwardRef as ReactComponent };